import Vue from 'vue'
import Router from 'vue-router'
import home from './views/home.vue'
import login from './views/login.vue'
import newlyAdded from './views/statistics/newlyAdded.vue'
import publicWelfare from './views/statistics/publicWelfare.vue'
import sourceOfCase from './views/statistics/sourceOfCase.vue'
import train from './views/statistics/train.vue'
import jobWanted from './views/statistics/jobWanted.vue'
import recruit from './views/statistics/recruit.vue'
//联盟表单
import unionForm from './views/lawUnion/unionForm.vue'
import unionList from './views/lawUnion/unionList.vue'
import blank from './views/lawUnion/blank.vue'
//村居法律平台
import platformHome from './views/rusticate/platformHome.vue'
//案源库
import caseList from './views/sourcebank/caseList.vue'
import caseLogin from './views/sourcebank/caseLogin.vue'


Vue.use(Router)
export default new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {path: '/', name: 'home', component: home,meta:{title:''}},
        {path: '/newlyAdded', name: 'statistics/newlyAdded', component: newlyAdded,meta:{title:'系统统计'}},
        {path: '/publicWelfare', name: 'statistics/publicWelfare', component: publicWelfare,meta:{title:'公益统计'}},
        {path: '/sourceOfCase', name: 'statistics/sourceOfCase', component: sourceOfCase,meta:{title:'案源统计'}},
        {path: '/recruit', name: 'statistics/recruit', component: recruit,meta:{title:'招聘统计'}},
        {path: '/jobWanted', name: 'statistics/jobWanted', component: jobWanted,meta:{title:'求职统计'}},
        {path: '/train', name: 'statistics/train', component: train,meta:{title:'培训统计'}},
        {path: '/login', name: 'login', component: login,meta:{title:'系统统计'}},
    //    法律联盟
        {path: '/unionForm', name: 'lawUnion/unionForm', component: unionForm,meta:{title:'公益法律服务联盟'}},
        {path: '/unionList', name: 'lawUnion/unionList', component: unionList,meta:{title:'公益法律服务联盟'}},
        {path: '/blank', name: 'lawUnion/blank', component: blank,meta:{title:'空白页面'}},
    // 村居法律服务平台
        {path: '/platformHome', name: 'rusticate/platformHome', component: platformHome,meta:{title:''}},
    // 案源库
        {path: '/caseList', name: 'sourcebank/caseList', component: caseList,meta:{title:'案源库'}},
        {path: '/caseLogin', name: 'sourcebank/caseLogin', component: caseLogin,meta:{title:'案源库'}},
    ]
})
